export default __webpack_public_path__ + "static/media/CNBC.2d63bcf7.png";